import script from "./productGroupsBasic.vue?vue&type=script&lang=ts&setup=true"
export * from "./productGroupsBasic.vue?vue&type=script&lang=ts&setup=true"

import "./productGroupsBasic.vue?vue&type=style&index=0&id=077ee2b7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-077ee2b7"]])

export default __exports__